// src/components/Footer.js
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaWhatsapp } from "react-icons/fa";

const Footer = () => {
  return (
    <>
      <footer
        className="text-light pt-5"
        style={{ background: "#1e1e2f", fontSize: "14px" }}
      >
        <Container>
          <Row>
            {/* About Us */}
            <Col md={6} sm={12} className="mb-4">
              <h5 className="fw-bold mb-3">About Us</h5>
              <p style={{ lineHeight: "1.6", textAlign: "justify" }}>
                Manav Adhikar Forum (MAF) is a non-profit organization that
                serves as the national body for social work worldwide. It is
                registered under the Government of India Act, 1882, and
                recognized by NITI Aayog, the Ministry of MSME, Fit India, and
                the Ministry of Social Justice and Empowerment – Government of
                India. MAF is also ISO 9001:2015 certified, demonstrating its
                commitment to quality standards, with a strong focus on social
                work.
              </p>
              <Link
                to="/About-Us"
                className="text-warning fw-semibold text-decoration-none"
              >
                Read More ...
              </Link>
            </Col>

            {/* Contact Us */}
            <Col md={6} sm={12} className="mb-4">
              <h5 className="fw-bold mb-3">Contact Us</h5>
              <p>
                <FaMapMarkerAlt className="me-2 text-warning" />
                <strong>Address:</strong> 2nd -FR, FL-C-3, Holding No-53,
                Ramkrishna Garh Road, Manickpur, LP-110/31/10/1, Kolkata, West
                Bengal-700079
              </p>
              <p>
                <FaPhoneAlt className="me-2 text-warning" />
                <strong>Phone No:</strong> 03369029507
                {/* , 01169269041 */}
              </p>
              <p>
                <FaWhatsapp className="me-2 text-warning" />
                <strong>WhatsApp No:</strong> +91 90646 34965
              </p>

              <p>
                <FaEnvelope className="me-2 text-warning" />
                <strong>Email:</strong>{" "}
                <a
                  href="mailto:manavadhikarforumindia@gmail.com"
                  className="text-light text-decoration-none"
                >
                  manavadhikarforumindia@gmail.com
                </a>
              </p>
            </Col>
          </Row>
          {/* Terms and Conditions, Privacy Policy, Refund Policy */}
          <Col md={12} className="text-center mt-4">
            <p className="mb-0">
              <Link
                to="/Terms-and-Conditions"
                className="text-warning text-decoration-none me-2"
              >
                Terms and Conditions
              </Link>
              |
              <Link
                to="/Privacy-Policy"
                className="text-warning text-decoration-none mx-2"
              >
                Privacy Policy
              </Link>
              |
              <Link
                to="/Refund-Policy"
                className="text-warning text-decoration-none ms-2"
              >
                Refund Policy
              </Link>
            </p>
          </Col>

          {/* Bottom Bar */}
          <Row className="border-top border-secondary pt-3 mt-3 text-center">
            <Col>
              <p className="mb-1">
                © {new Date().getFullYear()} Manav Adhikar Forum. All Rights
                Reserved.
              </p>
              <p className="text-muted mb-0" style={{ fontSize: "13px" }}>
                Powered by <span className="fw-semibold">Subham Sharma</span>
              </p>
            </Col>
          </Row>
        </Container>
      </footer>
    </>
  );
};

export default Footer;
